// extracted by mini-css-extract-plugin
export default {"form":"AdvancedTasksSearchForm_form__Asm-X"};